/**
 * Step indices and labels for the dashboard stepper.
 */
export const STEP_CONFIG = {
  APPLICATION: 0,
  OFFER_AGREEMENT: 1,
  ACCOUNT_SETUP: 2,
};

export const STEP_HEADERS = {
  [STEP_CONFIG.APPLICATION]: "Application",
  [STEP_CONFIG.OFFER_AGREEMENT]: "Offer & Agreement",
  [STEP_CONFIG.ACCOUNT_SETUP]: "Account Setup",
};
